import { useMutation } from "@apollo/client";
import { SIGN_EXTERNAL_REGISTRATION } from "@/modules/gateway/features/open-external-sign/api/sign-external-registration";
import { SignExternalRegistrationMutationVariables } from "gql/graphql";

export function useExternalSignEgovLink({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const [signRegistration, { loading }] = useMutation(
    SIGN_EXTERNAL_REGISTRATION,
  );

  const sign = async (variables: SignExternalRegistrationMutationVariables) => {
    const response = await signRegistration({
      variables,
    });

    if (response.data?.signExternalRegistration) {
      afterSubmit?.();
    }

    return response.data?.signExternalRegistration;
  };

  return {
    sign,
    loading,
  };
}
